<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <div class="font-bold mb-10">Sales Log</div>
        <div class="box-mini mb-10">
          <div class="p-15 pb-0">
            <div class="row">
              <div class="col-sm-4">
                <table>
                  <tr>
                    <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                    <td>
                      <flat-pickr :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-sm-4">
                <div class="row">
                  <div class="col-sm-4 col-form-label text-right">
                    Branch
                  </div>
                  <div class="col-sm-8">
                    <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                        <option :value="null">Please select</option>
                        <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div class="col-sm-4 text-right">
                <div class="search-header">
                  <div class="custom-search-container">
                    <div class="input-group custom-search">
                      <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                      <span class="icon-magnifier icon-input-custom"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="mb-0">
          <div class="p-15">
            <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields" class="table-fixedwidth text-center table-custom">
              <!-- <template slot="No." slot-scope="data">
                {{data.index + 1}}
              </template> -->
              <template v-slot:cell(created_at)="data">
<!--              <template slot="created_at" slot-scope="data">-->
                {{dateFormat(data.item.created_at)}}
              </template>
              <template v-slot:cell(member_id)="data">
<!--              <template slot="member_id" slot-scope="data">-->
                <div v-if="data.item.member && data.item.member.branch">
                  {{data.item.member.branch.codename}}{{data.item.member.id}}
                </div>
              </template>
              <template v-slot:cell(name)="data">
<!--              <template slot="name" slot-scope="data">-->
                <!-- {{data.item}} -->
                <div v-if="data.item.member">
                  {{data.item.member.first_name}} {{data.item.member.last_name}}
                </div>
              </template>
              <template v-slot:cell(sold_by)="data">
<!--              <template slot="sold_by" slot-scope="data">-->
                <div v-if="data.item.member && data.item.sales">
                  {{data.item.sales.sold_by}}
                </div>
              </template>
              <template v-slot:cell(pha)="data">
<!--              <template slot="sold_by" slot-scope="data">-->
              <b-badge v-if="data.item.pha == 1" :variant="'info'" >NO</b-badge>
              <b-badge v-else-if="data.item.pha == 0" :variant="'success'" >YES</b-badge>
              <b-badge v-else :variant="'info'" >No</b-badge>
              </template>
              <template v-slot:cell(membership_contract_category)="data">
                <div v-if="!data.item.membership_contract_category">
                  -
                </div>
                <div v-else>
                  {{data.item.membership_contract_category.name}}
                </div>
              </template>
              <template slot="countPrepaid" slot-scope="data">
                <div v-if="data.item.membership.membership_type_id == 2">
                  Rp. {{parseFloat(data.item.gross_amount).toLocaleString('id-ID', {maximumFractionDigits:2})}}
                </div>
                <div v-else>0</div>
              </template>
              <template v-slot:cell(payment_amount_1)="data">
                <div style="display: flex; justify-content:space-between">
                  <div style="width: 150px;"> {{ifPaymentNull(data.item.payment_type_1)}} {{ifPaymentNull(data.item.payment_card_1)}} </div>
                  <div style="width: 150px;">Rp. {{parseFloat(data.item.payment_amount_1).toLocaleString('id-ID', {maximumFractionDigits:2})}} </div>
                </div>
              </template>
              <template v-slot:cell(payment_amount_2)="data">
                <div style="display: flex; justify-content:space-between">
                  <div style="width: 150px;"> {{ifPaymentNull(data.item.payment_type_2)}} {{ifPaymentNull(data.item.payment_card_2)}} </div>
                  <div style="width: 150px;">Rp. {{parseFloat(data.item.payment_amount_2).toLocaleString('id-ID', {maximumFractionDigits:2})}} </div>
                </div>
              </template>
            </b-table>
            <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
                :total-pages="totalPage"
                @page-changed="pageOneChanged"
                prev-text="Prev" next-text="Next"/>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="40" alt="">
        <br>
        <div class="title-loading color-white">Please wait...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'saleslog',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'created_at',
          label: 'Date',
          sortable: true
        },
        {
          key: 'branch.name',
          label: 'Branch Name',
          sortable: true
        },
        {
          key: 'member_id',
          label: 'Member ID',
          sortable: true
        },
        {
          key: 'name',
          label: 'Member Name',
          sortable: true
        },
        {
          key: 'member.phone_number',
          label: 'Phone Number',
          sortable: true
        },
        {
          key: 'member.leads_source_type.name',
          label: 'Leads Source',
          sortable: true
        },
        {
          key: 'personal_trainer',
          label: 'Personal Trainer',
          sortable: false
        },
        {
          key: 'member.referral_pt.name',
          label: 'Refferal PT',
          sortable: false
        },
        {
          key: 'sold_by',
          label: 'Sold By',
          sortable: true
        },
        {
          key: 'membership_contract_category',
          label: 'Contract Category',
          sortable: true
        },
        {
          key: 'membership.name',
          label: 'Membership Type',
          sortable: true
        },
        {
          key: 'member.email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'transaction_detail.processing_fee_before_tax',
          label: 'PF (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.transaction_detail.processing_fee_before_tax).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: true
        },
        {
          key: 'transaction_detail.pro_rate_before_tax',
          label: 'Prorate (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.transaction_detail.pro_rate_before_tax).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: true
        },
        {
          key: 'transaction_detail.first_month_before_tax',
          label: 'First Month (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.transaction_detail.first_month_before_tax).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: false
        },
        {
          key: 'transaction_detail.last_month_before_tax',
          label: 'Last Month (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.transaction_detail.last_month_before_tax).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: false
        },
        {
          key: 'countPrepaid',
          label: 'Prepaid (Term)',
          sortable: false
        },
        {
          key: 'transaction_detail.vat_before_tax',
          label: 'VAT (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.transaction_detail.vat_before_tax).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: false
        },
        {
          key: 'voucher_amount',
          label: 'Voucher (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.voucher_amount).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: true
        },
        {
          key: 'gross_amount',
          label: 'Total Paid (IDR)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.gross_amount).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: false
        },
        {
          key: 'payment_amount_1',
          label: 'Payment 1 (IDR)',
          sortable: false
        },
        {
          key: 'payment_amount_2',
          label: 'Payment 2 (IDR)',
          sortable: false
        },
        {
          key: 'notes',
          label: 'Remark',
          sortable: false
        },
        {
          key: '',
          label: 'Assesment Book',
          sortable: false
        },
        {
          key: '',
          label: 'PT Name',
          sortable: false
        },
        {
          key: 'pha',
          label: 'PHA',
          sortable: false
        },
        {
          key: 'personal_trainer',
          label: 'Personal Trainer',
          sortable: false
        },
        {
          key: 'member.referral_pt.name',
          label: 'Refferal PT',
          sortable: false
        },
        {
          key: 'member.efd',
          label: 'EFD',
          sortable: false
        },
        {
          key: 'member.ndp',
          label: 'NDP',
          formatter: (value, key, item) => {
            return item.member.ndp ? item.member.ndp : '-'
          },
          sortable: false
        },
        {
          key: 'member.membership_expired_date',
          label: 'Expired Date',
          formatter: (value, key, item) => {
            return item.member.membership_expired_date ? moment(item.member.membership_expired_date).format('DD MMM YYYY') : '-'
          },
          sortable: false
        },
        {
          key: 'member.monthly_fee',
          label: 'MONTLY_FEE',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.member.monthly_fee).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: false
        },
      ],
      dateWeek: '',
      items: [],
      dataBranch: [],
      branch_id: null,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role,
      getID: Auth.Session.get().paradigm_id,
      dateString: '27-07-1993',
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))],
        onChange: this.onChange
      }
    }
  },
  methods: {
    onChange(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('crm/v1/leads/' + event).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    getRowCount (items) {
      return items.length
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    statusMembership (status) {
      return (status === 'Membership') ? 'success'
          : (status === 'On Progress') ? 'warning' : 'danger'
    },
    openPage (event) {
      this.$router.push(event)
    },
    todayNumber () {
      return moment().isoWeekday()
    },
    cutTime (value) {
      return (value).slice(0, -3)
    },
    dateFormat (value) {
      return moment(new Date(value)).format('DD MMM YYYY HH:mm')
    },
    getNumberDay (value) {
      return moment(new Date(value)).isoWeekday()
    },
    parseDateTime1 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD')
    },
    parseDateTime2 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    parseDateTime3 (value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'crm/v1/img/banner/' + value
    },
    ifPaymentNull (value) {
      var data = value
      var replaceValue = ''
      if (data === null) {
        replaceValue = ''
      }
      else {
        replaceValue = data.name
      }
      return replaceValue
    },
    changeBranch (event) {
      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/sales_report/sales_log?page=' + this.currentPage
      + '&limit=' + this.paginationLimit
      + '&sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData
      + '&start=' + dates1[0]
      + '&end=' + dates1[1]

      if (event != null) {
        url += '&branch_id=' + event
      }

      if (this.getRoleId == 3) url += '&sales_id=' + Auth.Session.get().paradigm_id

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    },
    exportReport() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/export/sales_report/sales_log?start_date='+dates[0]+'&end_date='+dates[1]

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      if (this.getRoleId == 3) url += '&sales_id=' + Auth.Session.get().paradigm_id

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Sales Log (Sales Report) '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })
    },
    fetchData() {
      let dates1 = this.exportDates.split(' to ')
      let url = 'crm/v1/sales_report/sales_log?page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start=' + dates1[0]
        + '&end=' + dates1[1]

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      if (this.getRoleId == 3) url += '&sales_id=' + Auth.Session.get().paradigm_id

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })

      let url_branch = `fitness/v1/branch?paradigm_id=${this.getID}&paradigm_role_id=${this.getRoleId}`
      url_branch = `fitness/v1/branch/`;

      axios.get(url_branch).then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
